module.exports = __webpack_public_path__ + "static/media/cidida-profile.0fe132a3.jpg";